import React, { Component } from "react";
import PageContent from "../PageContent";
import Switch from "../Switch";
import Strings from "@my-dld/assets/strings";
import { DataViewType, GridView, ListView } from "@my-dld/utils/UIUtils";
import { ImperialSystem, MetricSystem, UnitSystem } from "@my-dld/utils/UnitUtils";
import PageTitle from "../PageTitle";
import { DashboardBCItem, PathInfo } from "@my-dld/contexts/PageContext";
import { dispatch } from "@my-dld/utils/StoreUtils";
import Actions from "@my-dld/actions";
import { RenderPagination, RenderSearch } from "./GridDataView";
import { getAppServices } from "@10x/coreapp/index";
import CardNoData from "../CardNoData";

interface Props<T> {
	isLoading?: boolean;
	title: string;
	pageTitle?: string;
	hidePageTitle?: boolean;
	onViewTypeChange?: ( viewType: DataViewType ) => void;
	onUnitSystemChange?: ( unitSystem: UnitSystem ) => void;
	extraController?: () => React.ReactElement | null;
	renderListView: () => React.ReactElement | null;
	renderGridView: () => React.ReactElement | null;
	searchBarTitle?: string;
	onSearch?: ( searchKey?: string ) => void;
	totalCount?: number;
	onPageChange?: ( page: number ) => void;
	dataAvailable?: boolean;
	containerClass?: string;
	bcItems?: PathInfo[];
}

interface State {
	viewType: DataViewType;
	unitSystem: UnitSystem;
	searchKey?: string;
}


class ListGridDataView<T> extends Component<Props<T>, State> {
	constructor( props: Props<T> ) {
		super( props );
		const store = getAppServices().storeService.getStore();
		const viewType = store.getState().User.viewType;
		const unitSystem = store.getState().User.unit;
		this.state = {
			viewType: this.isMobileDevice() ? GridView : viewType ? viewType : ListView,
			unitSystem: unitSystem ? unitSystem : MetricSystem,
		};
	}

	 isMobileDevice() {
		var ua = navigator.userAgent;
		var checker = {
			iphone: ua.match(/(iPhone|iPod|iPad)/),
			blackberry: ua.match(/BlackBerry/),
			android: ua.match(/Android/)
		};
		if (checker.android || checker.iphone || checker.blackberry) {
			return true;
		}
		return false;
	}

	render() {
		const {
			isLoading, title, pageTitle, hidePageTitle, onUnitSystemChange, renderListView, renderGridView,
			children, extraController, searchBarTitle, onSearch, totalCount, onPageChange, dataAvailable, containerClass,
			bcItems = [],
		} = this.props;
		const { viewType } = this.state;
		return <PageContent
			title={ title }
			titleExtra={ dataAvailable ? <>
				{!this.isMobileDevice() &&
				<Switch
					id={ "viewType" }
					onLabel={ Strings.list }
					onIcon={ <i className="icon-grid-view"/> }
					offLabel={ Strings.grid }
					offIcon={ <i className="fa fa-th-list"/> }
					value={ viewType.Id === ListView.Id }
					onChange={ this.onViewTypeChange }
					extraContainerClass={ "tr-map-list" }/> }
				{ onUnitSystemChange && <Switch
					id={ "unitSystem" }
					onLabel={ Strings.sq_mt }
					offLabel={ Strings.sq_ft }
					value={ this.state.unitSystem.Id === MetricSystem.Id }
					onChange={ this.onUnitSystemChange }/> }
				{ extraController && extraController() }
			</> : undefined }
			hideQLinks={ true }
			containerClass={ containerClass }>
			{ isLoading && <span className="spinner-border" role="status">
                 <span className="sr-only">{ Strings.loading }</span>
             </span> }
			{ !isLoading && <>
				{ hidePageTitle !== true && <PageTitle paths={ [ DashboardBCItem, ...bcItems ] } title={ pageTitle ?? title }/> }
				{ children }
				{ dataAvailable && <>
					{ onSearch && <RenderSearch
						cmp={ this } title={ searchBarTitle }
						onSearch={ onSearch }/> }
					<>
						{ viewType.Id === ListView.Id && renderListView() }
						{ viewType.Id === GridView.Id && renderGridView() }
					</>
					{ totalCount !== undefined && onPageChange &&
						<RenderPagination
							totalCount={ totalCount ? totalCount : 0 }
							onPageChange={ onPageChange }/> }
				</> }
				{ !dataAvailable && <CardNoData containerClass="alert alert-warning"/> }
			</> }
		</PageContent>;
	}

	private onViewTypeChange = ( isList: boolean ) => {
		this.setState( {
			viewType: isList ? ListView : GridView,
		}, () => {
			const newType = this.state.viewType;
			if ( this.props.onViewTypeChange )
				this.props.onViewTypeChange( newType );
			dispatch( Actions.VIEW_TYPE_CHANGED, newType );
		} );
	};

	private onUnitSystemChange = ( isSqm: boolean ) => {
		this.setState( {
			unitSystem: isSqm ? MetricSystem : ImperialSystem,
		}, () => {
			const newSystem = this.state.unitSystem;
			if ( this.props.onUnitSystemChange )
				this.props.onUnitSystemChange( newSystem );
			dispatch( Actions.UNIT_CHANGED, newSystem );
		} );
	};
}

export default ListGridDataView;
